(() => {
  const initFaqBoard = (root = document) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll('.faq-board:not([data-faq-board-ready="true"])').forEach((board) => {
      board.dataset.faqBoardReady = 'true';
      board.classList.add('faq-board--animated');

      board.querySelectorAll('.faq-board__item').forEach((item) => {
        const summary = item.querySelector('summary');
        const answer = item.querySelector('.faq-board__answer');

        if (!summary || !answer) {
          return;
        }

        let closeTimer = 0;

        const finishClose = () => {
          window.clearTimeout(closeTimer);
          closeTimer = 0;
          item.open = false;
          item.classList.remove('is-closing');
          answer.style.height = '0px';
          answer.style.opacity = '0';
        };

        if (item.open) {
          item.classList.add('is-open');
          answer.style.height = 'auto';
          answer.style.opacity = '1';
        }

        const openItem = () => {
          window.clearTimeout(closeTimer);
          item.classList.remove('is-closing');
          item.open = true;
          item.classList.add('is-open');

          if (reduceMotion) {
            answer.style.height = 'auto';
            answer.style.opacity = '1';
            return;
          }

          answer.style.height = '0px';
          answer.style.opacity = '0';

          window.requestAnimationFrame(() => {
            answer.style.height = `${answer.scrollHeight}px`;
            answer.style.opacity = '1';
          });
        };

        const closeItem = () => {
          if (!item.open) {
            return;
          }

          item.classList.remove('is-open');
          item.classList.add('is-closing');

          if (reduceMotion) {
            finishClose();
            return;
          }

          answer.style.height = `${answer.scrollHeight}px`;
          answer.style.opacity = '1';

          window.requestAnimationFrame(() => {
            answer.style.height = '0px';
            answer.style.opacity = '0';
          });

          closeTimer = window.setTimeout(finishClose, 600);
        };

        answer.addEventListener('transitionend', (event) => {
          if (event.propertyName !== 'height') {
            return;
          }

          if (item.classList.contains('is-closing')) {
            finishClose();
          } else if (item.open) {
            answer.style.height = 'auto';
          }
        });

        answer.addEventListener('transitioncancel', () => {
          if (item.classList.contains('is-closing')) finishClose();
        });

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (item.open && item.classList.contains('is-open')) {
            closeItem();
          } else {
            openItem();
          }
        });

        answer.addEventListener('click', (event) => {
          if (event.target.closest('a, button, input, textarea, select, label')) {
            return;
          }

          closeItem();
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaqBoard());
  } else {
    initFaqBoard();
  }

  document.addEventListener('shopify:section:load', (event) => initFaqBoard(event.target));
})();
